import ClosePopUpButton from "../../ClosePopUpButton/ClosePopUpButton";
import { useContextValue } from '../../../context/context';
import { EuroIcon } from "../../../assets/cardIcons";
import './style.css';

//? Temporary data
const hourlyRatesData = ["10.00 - 15.00", "15.00 - 20.00", "20.00 - 25.00", "30.00 - 35.00"];

const HourlyRatePopUp = ({ onClose }) => {
	const { setHourlyRate, filledCards, setFilledCards } = useContextValue();

	const handleHourlyRate = (hourlyRate) => {
		setHourlyRate(hourlyRate);

		const newCard = { content: hourlyRate, isSelected: true, title: "Stundensatz", backgroundColor: "#10849D", icon: EuroIcon };
		const existingCardIndex = filledCards.findIndex(card => card.title === newCard.title);

		if (existingCardIndex !== -1) {
			// Якщо картка існує, створюємо новий масив з оновленою карткою
			const updatedCards = [...filledCards];
			updatedCards[existingCardIndex] = newCard;
			setFilledCards(updatedCards);
		} else {
			// Якщо картки немає, додаємо нову
			setFilledCards([...filledCards, newCard]);
		}

		onClose();
	}

	return (
		<div className="hourlyRate-popup">
			<div className="hourlyRate-options">
			{
				hourlyRatesData.map((hourlyRate, index) => <p key={index} onClick={() => handleHourlyRate(hourlyRate)} className="hourlyRate-option">{hourlyRate}</p>)
			}
			</div>
			{/* <button style={{marginTop: "25px"}} onClick={onClose}>Close</button> */}
			<ClosePopUpButton onClose={onClose} />
		</div>
	)
}

export default HourlyRatePopUp